import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

import makeStyles from '@mui/styles/makeStyles';
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
// import MenuItem from "@mui/material/MenuItem";
// import Menu from "@mui/material/Menu";
// import UserService from "../services/UserService";
import LanguageContext from "../LanguageContext";
import messages from "../services/messages";
import UserService from "../services/UserService";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

import firebase from "../firebase";
import { IconButton, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  boxShadow: {
    boxShadow: "0px 4px 7px rgba(0, 0, 0, 0.09)",
    backgroundColor: "#FFFFFF",
  },
  arrowBack: {
    background: "#FFFFFF",
    marginLeft: theme.spacing(-1),
    padding: theme.spacing(0.7),
    color: "#000000",
  },
  allClassesTitle: {
    marginLeft: theme.spacing(2),
    fontWeight: "bold",
  },
  // title: {
  //   display: "flex",
  //   [theme.breakpoints.up("md")]: {
  //     display: "none",
  //   },
  //   color: "#DAB43D",
  // },
  // search: {
  //   position: "relative",
  //   borderRadius: theme.shape.borderRadius,
  //   backgroundColor: fade(theme.palette.common.black, 0.15),
  //   "&:hover": {
  //     backgroundColor: fade(theme.palette.common.black, 0.25),
  //   },
  //   marginRight: theme.spacing(2),
  //   marginLeft: 0,
  //   width: "100%",
  //   [theme.breakpoints.up("sm")]: {
  //     marginLeft: theme.spacing(3),
  //     width: "auto",
  //   },
  // },
  // searchIcon: {
  //   padding: theme.spacing(0, 2),
  //   height: "100%",
  //   position: "absolute",
  //   pointerEvents: "none",
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  // },
  // inputRoot: {
  //   color: "inherit",
  // },
  // inputInput: {
  //   padding: theme.spacing(1, 1, 1, 0),
  //   // vertical padding + font size from searchIcon
  //   paddingLeft: `calc(1em + ${theme.spacing(4)})`,
  //   transition: theme.transitions.create("width"),
  //   width: "100%",
  //   [theme.breakpoints.up("md")]: {
  //     width: "40rem",
  //   },
  // },
  // sectionDesktop: {
  //   display: "none",
  //   [theme.breakpoints.up("md")]: {
  //     display: "flex",
  //   },
  // },
  // sectionMobile: {
  //   display: "flex",
  //   [theme.breakpoints.up("md")]: {
  //     display: "none",
  //   },
  // },
  logo: {
    marginRight: theme.spacing(1),
    height: "45px",
  },
}));

export default function TopBar(props) {
  const classes = useStyles();
  const language = useContext(LanguageContext);
  // const [anchorEl, setAnchorEl] = React.useState(null);
  const [name, setName] = React.useState(null);
  const [state, setState] = React.useState(null);

  let history = useHistory();

  const logout = () => {
    let stateName =
      state && state.name_en ? state.name_en.toLowerCase() : "maharashtra";
    let { mobile, userType } = UserService.getUserInfo();
    firebase.analytics().logEvent("logout_clicked", {
      state_name: stateName,
      mobile: mobile,
      user_type: userType,
      section: "topbar",
      user_source: props?.userSource,
    });
    UserService.logout();
    history.push("/");
    history.go(0);
  };

  useEffect(() => {
    const userInfo = UserService.getUserInfo();
    setName(userInfo.name);
    setState(userInfo.state);
  }, []);
  // const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  // const isMenuOpen = Boolean(anchorEl);
  // const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  // const handleProfileMenuOpen = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleMobileMenuClose = () => {
  //   setMobileMoreAnchorEl(null);
  // };

  // const handleMenuClose = () => {
  //   setAnchorEl(null);
  //   handleMobileMenuClose();
  // };

  // const menuId = "primary-search-account-menu";
  // let renderMenu = (
  //   <Menu
  //     anchorEl={anchorEl}
  //     anchorOrigin={{ vertical: "top", horizontal: "right" }}
  //     id={menuId}
  //     keepMounted
  //     transformOrigin={{ vertical: "top", horizontal: "right" }}
  //     open={isMenuOpen}
  //     onClose={handleMenuClose}
  //   >
  //     <MenuItem onClick={logout}>
  //       {messages["header.logout"][language]}
  //     </MenuItem>
  //   </Menu>
  // );

  // const mobileMenuId = "primary-search-account-menu-mobile";
  // let renderMobileMenu = (
  //   <Menu
  //     anchorEl={mobileMoreAnchorEl}
  //     anchorOrigin={{ vertical: "top", horizontal: "right" }}
  //     id={mobileMenuId}
  //     keepMounted
  //     transformOrigin={{ vertical: "top", horizontal: "right" }}
  //     open={isMobileMenuOpen}
  //     onClose={handleMobileMenuClose}
  //   >
  //     <MenuItem onClick={handleProfileMenuOpen}>
  //       <MenuItem onClick={logout}>
  //         {messages["header.logout"][language]}
  //       </MenuItem>
  //     </MenuItem>
  //   </Menu>
  // );

  return (
    <div className={classes.grow}>
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <AppBar position="static" className={classes.boxShadow}>
            <Toolbar>
              {props?.location !== `meetings-list-page` ? (
                <a href={"/dashboard"}>
                  <img
                    src={"../../icons/goldlogo.svg"}
                    alt="AgroStar Gold"
                    className={classes.logo}
                  />
                </a>
              ) : (
                <>
                  <IconButton
                    edge={"end"}
                    href={`/dashboard`}
                    className={classes.arrowBack}
                    onClick={() => {
                      firebase
                        .analytics()
                        .logEvent("back_to_dashboard_button_clicked", {
                          user_source: props.userSource,
                          page_name: window.location.pathname,
                        });
                    }}
                    size="large">
                    <ArrowBack />
                  </IconButton>

                  {/* <Typography
                    variant={"h6"}
                    className={classes.allClassesTitle}
                  >
                    {messages[`dashboard.live.sectionTitle`][language]}
                  </Typography> */}
                </>
              )}

              <div className={classes.grow} />
              {!UserService.checkUserLogin() &&
                props &&
                props.location &&
                props.location === "login" && (
                  <Button
                    variant={"outlined"}
                    onClick={() => {
                      let stateName =
                        state && state.name_en
                          ? state.name_en.toLowerCase()
                          : "maharashtra";
                      firebase.analytics().logEvent("signup_clicked", {
                        state_name: stateName,
                        user_source: props?.userSource,
                      });
                      history.push("/join");
                    }}
                    color={"primary"}
                  >
                    {messages["signup.signup"][language]}
                  </Button>
                )}
              {UserService.checkUserLogin() === true &&
                props.userSource == "WEB" && (
                  <Button
                    variant={"outlined"}
                    color={"primary"}
                    onClick={logout}
                  >
                    {messages["signup.signout"][language]}
                  </Button>
                )}
            </Toolbar>
          </AppBar>
        </Grid>
      </Grid>

      {/* {renderMobileMenu}
      {renderMenu} */}
    </div>
  );
}
